import { Quarter, UniversalObject } from './data';

export interface StrapiItem {
  id: number;
  documentId?: string;
  [key: string]: any;
}

export interface StrapiState {
  [modelName: string]: {
    data: StrapiItem[];
    loading: boolean;
    error: string | null;
    lastAddedId?: number | null;
    lastDocId?: string | null;
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export enum StrapiActionTypes {
  FETCH_REQUEST = 'strapi/FETCH_REQUEST',
  FETCH_SUCCESS = 'strapi/FETCH_SUCCESS',
  FETCH_FAILURE = 'strapi/FETCH_FAILURE',
  ADD_REQUEST = 'ADD_REQUEST',
  ADD_SUCCESS = 'ADD_SUCCESS',
  ADD_FAILURE = 'ADD_FAILURE',
  SET_LAST_ADDED_ID = 'SET_LAST_ADDED_ID',
  DELETE_REQUEST = 'DELETE_REQUEST',
  DELETE_SUCCESS = 'DELETE_SUCCESS',
  DELETE_FAILURE = 'DELETE_FAILURE',
  SET_LAST_DOC_ID = 'SET_LAST_DOC_ID',
  UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST',
  UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE',
  UPDATE_REQUEST = 'UPDATE_REQUEST',
  UPDATE_SUCCESS = 'UPDATE_SUCCESS',
  UPDATE_FAILURE = 'UPDATE_FAILURE',
  FETCH_ACTION_BY_CONTEXT_REQUEST = 'FETCH_ACTION_BY_CONTEXT_REQUEST',
  FETCH_ACTION_BY_CONTEXT_SUCCESS = 'FETCH_ACTION_BY_CONTEXT_SUCCESS',
  FETCH_ACTION_BY_CONTEXT_FAILURE = 'FETCH_ACTION_BY_CONTEXT_FAILURE',
  FETCH_COMMENT_BY_CONTEXT_REQUEST = 'FETCH_COMMENT_BY_CONTEXT_REQUEST',
  FETCH_COMMENT_BY_CONTEXT_SUCCESS = 'FETCH_COMMENT_BY_CONTEXT_SUCCESS',
  FETCH_COMMENT_BY_CONTEXT_FAILURE = 'FETCH_COMMENT_BY_CONTEXT_FAILURE',
}

export enum ReportActionTypes {
  FETCH_REPORT_ANSWERS_REQUEST = 'FETCH_REPORT_ANSWERS_REQUEST',
  FETCH_REPORT_ANSWERS_SUCCESS = 'FETCH_REPORT_ANSWERS_SUCCESS',
  FETCH_REPORT_ANSWERS_FAILURE = 'FETCH_REPORT_ANSWERS_FAILURE',

  FETCH_REPORT_STATUSES_REQUEST = 'FETCH_REPORT_STATUSES_REQUEST',
  FETCH_REPORT_STATUSES_SUCCESS = 'FETCH_REPORT_STATUSES_SUCCESS',
  FETCH_REPORT_STATUSES_FAILURE = 'FETCH_REPORT_STATUSES_FAILURE',

  FETCH_REPORT_DATA_REQUEST = 'FETCH_REPORT_DATA_REQUEST',
  FETCH_REPORT_DATA_SUCCESS = 'FETCH_REPORT_DATA_SUCCESS',
  FETCH_REPORT_DATA_FAILURE = 'FETCH_REPORT_DATA_FAILURE',

  FETCH_LINKED_ACTIONS_REQUEST = 'FETCH_LINKED_ACTIONS_REQUEST',
  FETCH_LINKED_ACTIONS_SUCCESS = 'FETCH_LINKED_ACTIONS_SUCCESS',
  FETCH_LINKED_ACTIONS_FAILURE = 'FETCH_LINKED_ACTIONS_FAILURE',

  FETCH_REPORT_DATA_WITH_ACTIONS_SUCCESS = 'FETCH_REPORT_DATA_WITH_ACTIONS_SUCCESS',
}

export interface FetchRequestAction {
  type: StrapiActionTypes.FETCH_REQUEST;
  payload: {
    modelName: string;
    params?: any;
    pagination?: {
      page: number;
      pageSize: number;
    };
  };
}

export interface SetLastAddedIdAction {
  type: StrapiActionTypes.SET_LAST_ADDED_ID;
  payload: {
    modelName: string;
    id: number | null;
  };
}

export interface FetchSuccessAction {
  type: StrapiActionTypes.FETCH_SUCCESS;
  payload: {
    modelName: string;
    data: StrapiItem[];
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export interface FetchFailureAction {
  type: StrapiActionTypes.FETCH_FAILURE;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface AddRequestAction {
  type: StrapiActionTypes.ADD_REQUEST;
  payload: {
    modelName: string;
    data: any;
  };
}

export interface AddSuccessAction {
  type: StrapiActionTypes.ADD_SUCCESS;
  payload: {
    modelName: string;
    data: StrapiItem;
  };
}

export interface AddFailureAction {
  type: StrapiActionTypes.ADD_FAILURE;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface SetLastDocIdAction {
  type: StrapiActionTypes.SET_LAST_DOC_ID;
  payload: {
    modelName: string;
    documentId: string | null;
  };
}

export interface DeleteRequestAction {
  type: StrapiActionTypes.DELETE_REQUEST;
  payload: {
    modelName: string;
    id: string;
  };
}

export interface DeleteSuccessAction {
  type: StrapiActionTypes.DELETE_SUCCESS;
  payload: {
    modelName: string;
    id: string;
  };
}

export interface DeleteFailureAction {
  type: StrapiActionTypes.DELETE_FAILURE;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface UploadFileRequestAction {
  type: StrapiActionTypes.UPLOAD_FILE_REQUEST;
  payload: {
    file: File;
    refId: number;
    title: string;
  };
}

export interface UploadFileSuccessAction {
  type: StrapiActionTypes.UPLOAD_FILE_SUCCESS;
  payload: {
    data: any;
  };
}

export interface UploadFileFailureAction {
  type: StrapiActionTypes.UPLOAD_FILE_FAILURE;
  payload: {
    error: string;
  };
}

export type StrapiActions =
  | FetchRequestAction
  | FetchSuccessAction
  | FetchFailureAction
  | AddRequestAction
  | AddSuccessAction
  | AddFailureAction
  | SetLastAddedIdAction
  | SetLastDocIdAction
  | DeleteRequestAction
  | DeleteSuccessAction
  | DeleteFailureAction
  | UploadFileRequestAction
  | UploadFileSuccessAction
  | UploadFileFailureAction
  | UpdateRequestAction
  | UpdateSuccessAction
  | UpdateFailureAction
  | FetchActionByContextRequestAction
  | FetchActionByContextSuccessAction
  | FetchActionByContextFailureAction
  | FetchCommentByContextRequestAction
  | FetchCommentByContextSuccessAction
  | FetchCommentByContextFailureAction;

export type FilterKey = 'direction' | 'block' | 'demandGop' | 'focusGop' | 'created';

export interface SelectionFilterValue {
  selected: boolean;
  selectedIds: string[];
  [key: string]: any;
}

export interface DateRangeFilterValue {
  startDate?: string;
  endDate?: string;
  [key: string]: any;
}

export type FilterValue = SelectionFilterValue | DateRangeFilterValue;

export interface FilterMappings {
  actions: {
    [key in FilterKey]?: string;
  };
  actionsSP: {
    [key: string]: string;
  };
}

export interface PaginationData {
  page: number;
  pageCount: number;
  total: number;
}

export interface UpdateRequestAction {
  type: StrapiActionTypes.UPDATE_REQUEST;
  payload: {
    modelName: string;
    documentId: string;
    data: any;
  };
}

export interface UpdateSuccessAction {
  type: StrapiActionTypes.UPDATE_SUCCESS;
  payload: {
    modelName: string;
    data: any;
  };
}

export interface UpdateFailureAction {
  type: StrapiActionTypes.UPDATE_FAILURE;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface ReportFilters {
  gopId?: string;
  year?: string;
  quarter?: string;
  groupIds?: string;
  factoryIds?: string;
  directionId?: number;
  isFocal?: any;
}

export interface ReportApiResponse<T> {
  success: boolean;
  data: T[];
  total: number;
  filters: ReportFilters;
  error?: string;
}

export interface PlanActionsContext {
  selectedGroup?: UniversalObject | null;
  selectedFactory?: UniversalObject;
  selectedGop?: UniversalObject;
  currentQuarter?: Quarter | null;
  currentYear?: number | null;
  currentDirection?: UniversalObject | null;
  currentBlock?: { id: number; title: string };
  currentRequirement?: {
    id: number;
    title: string;
    isFocal?: boolean;
  };
  isPrefillMode?: boolean;
}

export interface FetchReportAnswersRequestAction {
  type: ReportActionTypes.FETCH_REPORT_ANSWERS_REQUEST;
  payload: {
    filters: ReportFilters;
  };
}

export interface FetchReportAnswersSuccessAction {
  type: ReportActionTypes.FETCH_REPORT_ANSWERS_SUCCESS;
  payload: {
    data: any[];
  };
}

export interface FetchReportAnswersFailureAction {
  type: ReportActionTypes.FETCH_REPORT_ANSWERS_FAILURE;
  payload: {
    error: string;
  };
}

export interface FetchReportStatusesRequestAction {
  type: ReportActionTypes.FETCH_REPORT_STATUSES_REQUEST;
  payload: {
    filters: ReportFilters;
  };
}

export interface FetchReportStatusesSuccessAction {
  type: ReportActionTypes.FETCH_REPORT_STATUSES_SUCCESS;
  payload: {
    data: any[];
  };
}

export interface FetchReportStatusesFailureAction {
  type: ReportActionTypes.FETCH_REPORT_STATUSES_FAILURE;
  payload: {
    error: string;
  };
}

export interface FetchReportDataRequestAction {
  type: ReportActionTypes.FETCH_REPORT_DATA_REQUEST;
  payload: {
    filters: ReportFilters;
  };
}

export interface FetchReportDataSuccessAction {
  type: ReportActionTypes.FETCH_REPORT_DATA_SUCCESS;
  payload: {
    answers: any[];
    statuses: any[];
  };
}

export interface FetchReportDataFailureAction {
  type: ReportActionTypes.FETCH_REPORT_DATA_FAILURE;
  payload: {
    error: string;
  };
}

export interface FetchLinkedActionsRequestAction {
  type: ReportActionTypes.FETCH_LINKED_ACTIONS_REQUEST;
  payload: { filters: ReportFilters };
}

export interface FetchLinkedActionsSuccessAction {
  type: ReportActionTypes.FETCH_LINKED_ACTIONS_SUCCESS;
  payload: { data: any[] };
}

export interface FetchLinkedActionsFailureAction {
  type: ReportActionTypes.FETCH_LINKED_ACTIONS_FAILURE;
  payload: { error: string };
}

export interface FetchActionByContextRequestAction {
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_REQUEST;
  payload: {
    modelName: string;
    context: PlanActionsContext;
  };
}

export interface FetchActionByContextSuccessAction {
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_SUCCESS;
  payload: {
    data: any[];
  };
}

export interface FetchActionByContextFailureAction {
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_FAILURE;
  payload: {
    error: string;
  };
}

export interface StoreWithStrapi {
  gop: {
    gop: {
      [modelName: string]: {
        data: StrapiItem[];
        loading: boolean;
        error: string | null;
        lastAddedId?: number | null;
        lastDocId?: string | null;
      };
    };
    reports: {
      answers: {
        data: any[];
        loading: boolean;
        error: string | null;
      };
      statuses: {
        data: any[];
        loading: boolean;
        error: string | null;
      };
      actions: {
        data: any[];
        loading: boolean;
        error: string | null;
      };
      linkedActions: {
        data: any[];
        loading: boolean;
        error: string | null;
      };
      combined: {
        loading: boolean;
        error: string | null;
      };
    };
    [key: string]: any;
  };
}

export interface FetchCommentByContextRequestAction {
  type: typeof StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_REQUEST;
  payload: {
    modelName: string;
    context: PlanActionsContext;
  };
}

export interface FetchCommentByContextSuccessAction {
  type: typeof StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_SUCCESS;
  payload: {
    data: any[];
  };
}

export interface FetchCommentByContextFailureAction {
  type: typeof StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_FAILURE;
  payload: {
    error: string;
  };
}
